import React from 'react';
import {Download, Gamepad2, Calculator, TrendingUp} from 'lucide-react';
import section from '../../styles/components/sections.module.css';
import styles from '../../styles/components/HowToPlaySection.module.css';

const steps = [
  {icon: Download, title: 'Download', description: 'Get the app on iOS or Android, or play on the web.'},
  {icon: Gamepad2, title: 'Choose Your Mode', description: 'Pick a game mode and difficulty level.'},
  {icon: Calculator, title: 'Solve & Score', description: 'Answer arithmetic questions as fast as you can.'},
  {icon: TrendingUp, title: 'Climb the Ranks', description: 'Your scores appear on weekly and all-time leaderboards.'},
];

const HowToPlaySection: React.FC = () => {
  return (
    <section className={`${section.section} ${section.sectionAlt}`}>
      <div className={section.container}>
        <h2 className={section.title}>How It Works</h2>
        <p className={section.subtitle}>Get started in seconds.</p>
        <div className={styles.steps}>
          {steps.map((step, i) => (
            <div className={styles.step} key={step.title}>
              <div className={styles.stepNumber}>{i + 1}</div>
              <step.icon size={28} className={styles.stepIcon} />
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToPlaySection;
